/**
 * localizedDisplay — returns the locale-specific display name for a taxonomy item
 * Falls back to English display if locale key not present
 */

const LOCALE_FIELD_MAP = {
  es: 'display_es',
  pt: 'display_pt',
  ko: 'display_ko',
  ja: 'display_ja',
  fr: 'display_fr',
};

/**
 * @param {object} item - taxonomy item with display, display_es, display_pt, etc.
 * @param {string} locale - locale code e.g. 'en', 'es', 'pt'
 * @returns {string}
 */
export function getLocalizedDisplay(item, locale) {
  if (!item) return '';
  if (!locale || locale === 'en') return item.display || '';
  const field = LOCALE_FIELD_MAP[locale];
  if (field && item[field]) return item[field];
  return item.display || '';
}

/**
 * Generic locale-suffixed field accessor with EN fallback.
 * getLocalizedField(cat, 'teaser', 'es') -> cat.teaser_es || cat.teaser
 * Works for teaser/description/referralInfo/symptoms/display or any field
 * following the `<field>_<locale>` convention.
 *
 * @param {object} item - taxonomy/data object
 * @param {string} field - base (English) field name
 * @param {string} locale - locale code e.g. 'en', 'es'
 * @returns {*} localized value, falling back to the English field
 */
export function getLocalizedField(item, field, locale) {
  if (!item) return '';
  const base = item[field] !== undefined ? item[field] : '';
  if (!locale || locale === 'en') return base;
  const localized = item[`${field}_${locale}`];
  return localized !== undefined && localized !== null && localized !== ''
    ? localized
    : base;
}
